import React, { useCallback } from 'react';
import { connect } from 'react-redux';
import cn from 'classnames';

import ResponsiveBox from 'components/generic/ResponsiveBox.component';
import CurrencySign from 'components/price/CurrencySign.component';
import { useTranslation } from 'providers/GILT.provider';
import { useTheme } from 'providers/Theme.provider';
import { selectCurrentSalonPosFlow, selectCurrentSalonTakeTipViaPos } from 'selectors/currentSalon.selectors';

import { updateAdditionalDiscount, updateAdditionalDiscountReason, updateTipAmount } from 'checkout/actions';

import CN from './CheckoutTips.module.scss';

const AMOUNT_INPUT_PLACEHOLDER = '0.00';

const CheckoutTips = ({ takeTipViaPos, canTakePosPayment, tipAmount, updateTipAmount }) => {
  const { isDarkMode } = useTheme();
  const { t } = useTranslation();

  const onTipChange = useCallback(
    (event) => {
      let tip = event.target.value;
      if (tip === '') {
        tip = 0;
      } else if (isNaN(tip)) {
        return;
      }
      updateTipAmount(tip);
    },
    [updateTipAmount],
  );

  return (
    <div
      data-bem="CheckoutTips"
      className={cn({
        [CN.component]: true,
        [CN.dark]: isDarkMode,
      })}
    >
      {takeTipViaPos && canTakePosPayment && (
        <ResponsiveBox.Mobile>
          <div className={CN.tipInfoText}>{t('checkout.checkoutTips.alertMessage')}</div>
        </ResponsiveBox.Mobile>
      )}

      <div className="table-checkout tip">
        <div className="thead gray">
          <div className="cell-product">{t('checkout.checkoutTips.tips')}</div>
          <div className="cell-staff" />
          <div className="cell-price">{t('checkout.checkoutTips.amount')}</div>
          <div className="cell-discount" />
          <div className="cell-total">{t('common.total')}</div>
          <div className="cell-last" />
        </div>
        <div className="tbody">
          <div className="tr">
            <div className="cell-product">{t('checkout.checkoutTips.staffTips')}</div>
            <div className="cell-staff" />
            <div className="cell-price">
              <div>
                <CurrencySign />
                <input
                  type="text"
                  className="chk-amount-input"
                  placeholder={AMOUNT_INPUT_PLACEHOLDER}
                  value={tipAmount ? tipAmount : ''}
                  onChange={onTipChange}
                  autoComplete="off"
                />
              </div>
            </div>
            <div className="cell-discount">
              {takeTipViaPos && canTakePosPayment && (
                <ResponsiveBox.Desktop>
                  <div className={CN.tipInfoText}>{t('checkout.checkoutTips.alertMessage')}</div>
                </ResponsiveBox.Desktop>
              )}
            </div>
            <div className="cell-total">
              <CurrencySign value={tipAmount} />
            </div>
            <div className="cell-last" />
          </div>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  ...state.checkout.data,
  takeTipViaPos: selectCurrentSalonTakeTipViaPos(state),
  canTakePosPayment: selectCurrentSalonPosFlow(state),
});

const mapDispatchToProps = (dispatch) => ({
  updateAdditionalDiscount(additionalDiscount) {
    dispatch(updateAdditionalDiscount(additionalDiscount));
  },

  updateAdditionalDiscountReason(additionalDiscountReason) {
    dispatch(updateAdditionalDiscountReason(additionalDiscountReason));
  },
  updateTipAmount(tipAmount) {
    dispatch(updateTipAmount(tipAmount));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(CheckoutTips);
